import { render, staticRenderFns } from "./apply-privilege.vue?vue&type=template&id=5c691694&"
import script from "./apply-privilege.vue?vue&type=script&lang=js&"
export * from "./apply-privilege.vue?vue&type=script&lang=js&"
import style0 from "./apply-privilege.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports